import React, { useState } from 'react';
import { Button, Typography, CircularProgress, Box, Dialog, FormControl, InputLabel, MenuItem, Select, Input } from '@mui/material';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { url } from "../../api/axios_client";
import axios from "../../api/axios_client";

const ResultsView = ({ handleSubmit }) => {
    const [loading, setLoading] = useState(false);
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState("");
    const [uploading, setUploading] = useState(false);
    const [reportName, setReportName] = useState("");

    const areas = useSelector((state) => state.mapState.areas);
    const response = useSelector((state) => state.landDegradation.results);
    const landDegradationState = useSelector((state) => state.landDegradation);

    const countries = [
        "Algeria", "Bahrain", "Comoros", "Djibouti", "Egypt", "Iraq",
        "Jordan", "Kuwait", "Lebanon", "Libya", "Mauritania", "Morocco",
        "Oman", "Palestine", "Qatar", "Saudi Arabia", "Somalia", "Sudan",
        "Syria", "Tunisia", "United Arab Emirates", "Yemen"
    ];

    const validateData = () => {
        if (!areas || !areas[0] || !areas[0].coordinates) {
            toast.error('Please select an area first');
            return false;
        }
        return true;
    };

    const handleUpload = async () => {
        if (!selectedCountry || !reportName) {
            toast.error("Please fill in all required fields");
            return;
        }

        try {
            setUploading(true);
            const res = await axios.post(`${url}/reports`, {
                source: "landdegradation",
                name: reportName,
                country: selectedCountry,
                container: response?.uploaded_blob?.container,
                blob: response?.uploaded_blob?.blob
            });

            if (res.status === 201) {
                toast.success("Results uploaded successfully");
                setOpenUploadDialog(false);
            } else {
                toast.error("Failed to upload results");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        } finally {
            setUploading(false);
        }
    };

    return (
        <Box className="land-degradation-config">
            <Box className="config-section">
                <Typography className="config-title" variant="h5" gutterBottom>
                    Land Degradation
                </Typography>
                <Typography className="config-title" variant="h6" gutterBottom>
                    Results
                </Typography>

                <Box display="flex" flexDirection="column" alignItems="center" gap={3} p={4}>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            className="submit-button"
                        >
                            {response ? "Re-submit" : "Submit"}
                        </Button>
                    )}

                    {response && (
                        <Box display="flex" gap={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                href={response.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Download Results
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => setOpenUploadDialog(true)}
                            >
                                Upload to Repository
                            </Button>
                        </Box>
                    )}
                </Box>

                <Dialog
                    open={openUploadDialog}
                    onClose={() => setOpenUploadDialog(false)}
                    maxWidth="sm"
                    fullWidth
                >
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom>
                            Upload Results to Repository
                        </Typography>

                        <Box display="flex" flexDirection="column" gap={3} mt={2}>
                            <FormControl fullWidth>
                                <InputLabel>Results Name</InputLabel>
                                <Input
                                    value={reportName}
                                    onChange={(e) => setReportName(e.target.value)}
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <InputLabel>Select Country</InputLabel>
                                <Select
                                    value={selectedCountry}
                                    onChange={(e) => setSelectedCountry(e.target.value)}
                                    label="Select Country"
                                >
                                    {countries.map((country) => (
                                        <MenuItem key={country} value={country}>
                                            {country}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Box display="flex" gap={2} justifyContent="flex-end">
                                <Button
                                    onClick={() => setOpenUploadDialog(false)}
                                    variant="outlined"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleUpload}
                                    disabled={uploading || !selectedCountry || !reportName}
                                >
                                    {uploading ? "Uploading..." : "Upload"}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Dialog>
            </Box>
        </Box>
    );
};

export default ResultsView;